const loginWithEmailRules = {
  emailAddress: [
    {
      required: true,
      message: "User's email address is required",
    },
  ],
  securityCode: [
    {
      required: true,
      message: 'Security code is required',
    },
  ],
}

export default loginWithEmailRules
